import { FC, useState } from 'react';
import { Menu, Button, Text, ActionIcon } from '@mantine/core';
import { IconUserCircle, IconArrowBarLeft, IconWorld, IconMenu2 } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

// internal
import { Handle } from '@fullloop-platform/handle-service';
import { token } from 'core-request';

interface HeaderProps {
  menuButton?: boolean;
  backButton?: boolean;
  onClickHide: () => void;
}

const Header: FC<HeaderProps> = (props) => {
  const [language, setLanguage] = useState<string>('EN');

  const handleLogout = () => {
    token.delComposerAccess();
    token.delComposerRefresh();
    Handle.handleLogout();
  };

  return (
    <div className="flex justify-between bg-primary h-[60px]">
      <div className="flex items-center">
        <div className="pl-3 mx-2 items-center flex">
          <img src="/assets/FeedbackEX_white.png" alt="logo" width="160" />
        </div>
        {props.menuButton && (
          <div className="mx-2 flex justify-center">
            <ActionIcon variant="transparent" onClick={() => props.onClickHide()}>
              <IconMenu2 className="text-white" size={30} />
            </ActionIcon>
          </div>
        )}
      </div>
      <div className="flex items-center">
        <div className="flex items-center">
          {props.backButton && (
            <div className="mx-2">
              <Link to="/" className="cursor-pointer">
                <Button
                  variant="transparent"
                  leftSection={<IconArrowBarLeft size={30} className="text-white border-2 border-white" />}
                  p={0}
                >
                  <label className="text-white">Project</label>
                </Button>
              </Link>
            </div>
          )}
          <div className="mx-2 ml-3">
            <Menu>
              <Menu.Target>
                <Button type="button" size="xs" variant="transparent" p={0}>
                  <IconWorld size={22} color="white" />
                  <Text className="ml-1" c="white" size="sm">
                    {language}
                  </Text>
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                {/* TODO implement translate */}
                <Menu.Item>English</Menu.Item>
                {/* <Menu.Item>ภาษาไทย</Menu.Item> */}
              </Menu.Dropdown>
            </Menu>
          </div>
          <div className="mx-2 mr-4">
            <Menu>
              <Menu.Target>
                <Button type="button" size="xs" variant="transparent" p={0}>
                  <IconUserCircle className="text-white" size={25} />
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item onClick={handleLogout}>Logout</Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
